import React, { ReactNode } from 'react';
import { Button, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';

export const ratingCardId = (key: string) => `rating-card-${key}`;

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 16,
    padding: '20px 24px 16px',
    borderBottom: '1px solid #e6e9ee',
  },
  headerText: { flex: 1, minWidth: 0 },
  title: { fontSize: 20, fontWeight: 700, color: '#111827' },
  subtitle: { fontSize: 13, color: '#6b7280', marginTop: 4 },
  body: { display: 'grid', gridTemplateColumns: '520px 1fr', height: '56vh', minHeight: 0 },
  pane: { overflowY: 'auto', padding: '20px 24px 24px', minHeight: 0 },
  footer: { display: 'flex', alignItems: 'center', gap: 16, padding: '16px 24px', borderTop: '1px solid #e6e9ee' },
  footerText: { flex: 1, fontSize: 12, color: '#6b7280' },
  submitDone: { backgroundColor: '#2e9e4f', '&:hover': { backgroundColor: '#24853f' } },
  remaining: {
    marginLeft: 10,
    fontSize: 12,
    backgroundColor: 'rgba(255,255,255,.22)',
    padding: '2px 8px',
    borderRadius: 10,
  },
});

interface IProps {
  open: boolean;
  title: string;
  subtitle: string;
  rail: ReactNode;
  footerText: string;
  submitLabel: string;
  remaining: number;
  loading: boolean;
  onSubmit(): void;
  onClose(): void;
  children: ReactNode;
}

const RatingDialogLayout = ({
  open,
  title,
  subtitle,
  rail,
  footerText,
  submitLabel,
  remaining,
  loading,
  onSubmit,
  onClose,
  children,
}: IProps) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <div className={classes.header}>
        <div className={classes.headerText}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </div>
        <IconButton aria-label="Закрыть" size="small" onClick={onClose}>
          <Close />
        </IconButton>
      </div>

      <div className={classes.body}>
        {rail}
        <div className={classes.pane}>{children}</div>
      </div>

      <div className={classes.footer}>
        <Typography className={classes.footerText}>{footerText}</Typography>
        <Button
          variant="contained"
          color="primary"
          className={remaining === 0 ? classes.submitDone : undefined}
          disabled={loading}
          onClick={onSubmit}
        >
          {submitLabel}
          {remaining > 0 && <span className={classes.remaining}>осталось {remaining}</span>}
        </Button>
      </div>
    </Dialog>
  );
};

export default RatingDialogLayout;
